import React from 'react'

import { AsyncSelect } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import * as ProductosCrud from 'services/producto.service'

const FilaBusquedaTemplate = ({ esFilaActiva, seleccionarProductoViaBusquedaHandler }) => {
  const __adminContext = React.useContext(AdminContext)

  const loadProductosSelect = (inputValue, resolve) => {
    ProductosCrud.obtenerAsSelect2Presentaciones({
      busqueda: inputValue
    }).then(({ data }) => resolve(data))
  }

  return (
    <AsyncSelect
      selectId='productoSelect'
      loadOptions={loadProductosSelect}
      onChange={seleccionarProductoViaBusquedaHandler}
      defaultMenuIsOpen={esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
      autoFocus={esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
    />
  )
}

export default React.memo(FilaBusquedaTemplate)
